<wiz-hgroup  width="100%" height="100%" horizontalAlign="end">
               
    <wiz-icon class="basicIcon white hover" [wizTooltip]="'$.common.home.$'"
     tooltipPlacement="right" (click)="do('home')"
     [visible]="doShow('init')">
    <mat-icon>home</mat-icon></wiz-icon>    
    <wiz-icon class="basicIcon white hover" [visible]="doShow('thumb')"
                (click)="do('thumb')">grid</wiz-icon>
    <wiz-icon class="basicIcon white hover" [visible]="doShow('list')" 
                (click)="do('list')">view-list</wiz-icon>
    <wiz-icon class="basicIcon white hover" [visible]="doShow('add')" 
                (click)="do('add')">item</wiz-icon>
    <wiz-icon class="basicIcon white hover" [visible]="doShow('gatling')" 
                (click)="do('gatling')"><mat-icon>bolt</mat-icon></wiz-icon>

    <wiz-icon class="basicIcon white hover" [visible]="isVerbose" (click)="do('log')"><mat-icon>pets</mat-icon></wiz-icon>



    <wiz-hgroup  width="100%" height="100%" horizontalAlign="end">
        <!-- <wiz-label [wizLabel]="applicationVersion"></wiz-label> -->
        <wiz-icon class="basicIcon white hover"
                [wizTooltip]="'$.common.help.$'" (click)="do('help')" tooltipPlacement="bottom"><mat-icon>help_outline</mat-icon></wiz-icon>
    </wiz-hgroup>
    
</wiz-hgroup>

